<template>
  <section id="login-page">
    <!-- <div class="row mb-5">
      <div class="col-md-12">
        <h1 class="text-center">Sign In</h1>
      </div>
    </div> -->

    <div class="row justify-content-center">
      <div class="row" v-if="!signIn">
        <div class="col-md-5 mx-auto mt-5">
          <form @submit.prevent="blockRequests" id="signin-form">
            <div class="form-group m-label-left">
              <input
                required
                type="email"
                class="form-control"
                :class="{
                  'is-invalid': $v.form.email.$error,
                  'is-valid': !$v.form.email.$invalid,
                }"
                v-model.trim.lazy="$v.form.email.$model"
                id="login-email"
                aria-describedby="emailLogin"
                minlength="1"
                style="padding-left: 16px"
              />
              <label for="login-email">Email</label>
            </div>

            <div class="form-group m-label-left">
              <input
                :type="passwordType"
                class="form-control password-input"
                :class="{
                  'is-invalid': $v.form.password.$error,
                  'is-valid': !$v.form.password.$invalid,
                }"
                id="login-password"
                aria-label="Password"
                aria-describedby="passwordHelp"
                required
                v-model.trim.lazy="$v.form.password.$model"
                style="padding-left: 16px"
              />
              <label for="login-password">Password</label>
              <span>
                <i
                  class="password-icon"
                  :class="[passwordIcon]"
                  @click="hidePassword = !hidePassword"
                ></i>
              </span>
            </div>

            <div class="form-buttons text-center">
              <button type="submit" class="btn btn-secondary btn-custom px-5">Log In</button>
            </div>
          </form>

          <!--         <section>
          <p class="separator mt-5">
            <span>OR</span>
          </p>

          <div class="social-buttons text-center mb-xs-0">
            <LinkedInButton @click="linkedInLogin">Sign In with LinkedIn</LinkedInButton>
          </div>
        </section> -->

          <div v-if="$v.form.$error">
            <div
              v-if="!$v.form.password.required"
              class="alert alert-danger text-center"
              role="alert"
            >
              The password field is required.
            </div>
          </div>

          <div v-if="$v.form.$error">
            <div v-if="!$v.form.email.required" class="alert alert-danger text-center" role="alert">
              The email field is required.
            </div>
          </div>

          <div v-if="!$v.form.password.minLength">
            <div class="alert alert-danger text-center" role="alert">
              Password must have at least {{ $v.form.password.$params.minLength.min }} characters.
            </div>
          </div>

          <div class="footer-small-link mt-4">
            <p class="text-center">
              <span
                href="#"
                id="forgotten-password"
                class="link"
                @click="$emit('go-to-reset-password', $event)"
                >Forgotten your password?</span
              >
            </p>
          </div>
        </div>
        <div class="col-md-8 mx-auto text-center">
          <!-- End .card -->
          <div class="footer-small-link text-center mt-1">
            <p class="text-center">
              Not a member?
              <span id="register-link" class="link" @click="$emit('go-to-register', $event)"
                >Sign up as Candidate</span
              >
              or
              <span
                id="register-link"
                class="link"
                @click="$emit('go-to-register-employer', $event)"
                >Sign up as Employer</span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />
  </section>
</template>

<script>
import { mapActions } from 'vuex';

import { required, minLength, email } from 'vuelidate/lib/validators';
import { userRoleMixin } from '../../mixins/userRoleMixin';
import { errorService } from '../../services/errorService';

import Spinner from '../common/LoadingSpinner/Spinner.vue';

export default {
  components: { Spinner },
  mixins: [userRoleMixin],
  data: () => ({
    reToken: '',
    isLoading: false,
    signIn: false,
    hidePassword: true,
    errorMessage: null,
    errorCounts: 0,
    form: {
      email: '',
      password: '',
    },
  }),
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
    },
  },
  computed: {
    passwordType() {
      return this.hidePassword ? 'password' : 'text';
    },
    passwordIcon() {
      return this.hidePassword ? 'far fa-eye-slash' : 'far fa-eye';
    },
  },
  methods: {
    ...mapActions(['retrieveUserProfile', 'retrieveAllCountries', 'retrieveLanguagesList']),
    linkedInLogin() {
      this.$store.dispatch('LinkedInProvider', {
        jobId: this.$route.params.job_id,
        from: 'login',
      });
    },

    blockRequests() {
      if (this.errorCounts >= 5) {
        this.isLoading = false;
        this.$toasted.error('Too many attempts please try again later.', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        setTimeout(() => {
          this.errorCounts = 0;
        }, 30000);
      } else {
        this.getCaptcha();
      }
    },
    getCaptcha() {
      let vm = this;
      const SIGNIN = () => this.signin();
      grecaptcha
        .execute('6LdyDhspAAAAAJWVsgRkufJ8fAJBeSDpWDPUsvAn', { action: 'submit' })
        .then(function(token) {
          vm.reToken = token;
          SIGNIN();
        });
    },
    signin() {
      const { email, password } = this.form;

      this.isLoading = true;

      if (!localStorage.getItem('acc') || !localStorage.getItem('token')) {
        this.$store
          .dispatch('retrieveToken', {
            email,
            password,
            'g-recaptcha-response': this.reToken,
          })
          .then(response => {
            this.signIn = false;

            const { user_type } = response.data;

            if (user_type == this.userType('admin')) {
              this.retrieveUserProfile().then(() => {
                this.$router.push({ name: 'admin-jobs' });
                this.$toasted.success('You are successfully logged in as Admin.', {
                  theme: 'bubble',
                  icon: 'fa-check-circle',
                  position: 'bottom-right',
                  duration: 3000,
                });
              });
            } else if (user_type == this.userType('recruiter')) {
              this.$router.push({ name: 'recruiter-jobs' });

              this.$toasted.success('You are successfully logged in as Recruiter.', {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              });
            } else if (user_type == this.userType('user')) {
              this.$router.push({ name: 'manager-user-jobs' });

              this.$toasted.success('You are successfully logged in as User.', {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              });
            } else if (user_type == this.userType('manager')) {
              this.$store
                .dispatch('managerStoreModule/retrieveManagerProfile')
                .then(() => {
                  this.$router.push({ name: 'manager-jobs' });

                  this.$toasted.success('You are successfully logged in as Manager.', {
                    theme: 'bubble',
                    icon: 'fa-check-circle',
                    position: 'bottom-right',
                    duration: 5000,
                  });
                })
                .catch(err => {
                  this.$toasted.error(errorService(err), {
                    theme: 'bubble',
                    icon: 'fa-check-circle',
                    position: 'bottom-right',
                    duration: 5000,
                  });
                });
            } else if (user_type == this.userType('user')) {
              this.$toasted.success('You are successfully logged in as User.', {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              });
            } else if (user_type == this.userType('candidate')) {
              if (this.$route.params.jobad_id) {
                localStorage.setItem('applyId', this.$route.params.jobad_id);
              }
              this.$router.push({ name: 'user-profile' });
            }
          })
          .catch(err => {
            this.errorCounts++;

            this.signIn = false;
            this.isLoading = false;
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 5000,
            });
          });
      } else {
        this.$router.push({ name: 'admin-jobs' }) || this.$router.push({ name: 'manager-jobs' });
      }

      /* Initial retrieving of langs and countries */
      this.retrieveAllCountries();
      this.retrieveLanguagesList();
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';
.link {
  color: #0088cc;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.password-icon {
  position: absolute;
  right: 1rem;
  top: 1rem;
  color: $color-black;
}
.form-group {
  position: relative;
}
</style>
